export default __webpack_public_path__ + "static/media/comet.046aa4f5.jpg";